import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./newseventdetails.css";

const BlogDetails = () => {
  const { id } = useParams(); // <-- using ID now
  const { i18n, t } = useTranslation();
  const lang = i18n.language || "ta";

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("Fetching event ID:", id);
    setLoading(true);
    axios
      .get(`https://admin.cmpranesh-admk.com/api/getEventDetails.php?id=${id}`)
      .then(res => {
        console.log("Event data:", res.data);
        setPost(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching event:", err.response?.data || err.message);
        setError(err.response?.data?.message || "Error fetching event");
        setLoading(false);
      });
  }, [id]);

  if (loading) return <div>{t("loading") || "Loading..."}</div>;
  if (error) return <div>{t("errorLoading") || error}</div>;
  if (!post) return <div>{t("eventNotFound") || "Event not found."}</div>;

  const content = lang === "ta" ? post.content_ta : post.content_en;
  const paragraphs = content.split("\n").filter(p => p.trim() !== "");

  return (
    <div className="blog-details-container">
      <div className="blog-details-first-row">
        <div className="blog-details-left">
          <img
            src={post.image}
            alt={lang === "ta" ? post.title_ta : post.title_en}
            onError={e => (e.target.src = "/default-image.png")}
          />
        </div>
        <div className="blog-details-right">
          <h3>{lang === "ta" ? post.title_ta : post.title_en}</h3>
          {paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </div>

      {paragraphs.length > 1 && (
        <div className="blog-details-full-width">
          {paragraphs.slice(1).map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      )}

      <Link to="/event" className="back-to-blogs">
  ← {lang === "ta" ? "நிகழ்வுகளுக்குச் செல்லவும்" : "Back to Events"}
</Link>
    </div>
  );
};

export default BlogDetails;
